<ng-container *ngIf="authorized">
    <div class="text-center">
        <app-loading-indicator *ngIf="loading" [size]="16"></app-loading-indicator>
    </div>
    
    
    <button *ngIf="!loading" (click)="onDownloadCalendar($event)" class="btn btn-primary" id="btn-schedule-meeting">
        <fa-icon [icon]="faClock"></fa-icon>Schedule Meeting
    </button>
</ng-container>